<div class="flex justify-end">
  <app-close-chip (closed)="dismissed.emit()" />
</div>
<h2 mat-dialog-title class="text-title text-center">{{ titleKey | translate }}</h2>
<mat-dialog-content class="flex flex-col">
  <p *ngIf="messageKey" class="text-base">{{ messageKey | translate }}</p>

  <ul *ngIf="reasons?.length" class="list-disc pl-5 space-y-2">
    <li *ngFor="let reason of reasons" class="text-sm">{{ reason | translate }}</li>
  </ul>

  <p *ngIf="instructionKey" class="text-base font-medium">{{ instructionKey | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="flex flex-col items-center w-full gap-2">
    <button
      *ngIf="primaryActionLabelKey"
      mat-raised-button
      color="accent"
      class="!w-full !ml-0"
      (click)="primaryAction.emit()">
      {{ primaryActionLabelKey | translate | uppercase }}
    </button>
    <button
      *ngIf="showSupportAction"
      mat-stroked-button
      class="!w-full !ml-0 !border !border-solid !border-default-dark !bg-default-background"
      (click)="onSupportClick()">
      <mat-icon svgIcon="ph-regular-phone-call"></mat-icon>
      {{ 'components.error_dialog.support_button' | translate | uppercase }}
    </button>
    <button
      *ngIf="secondaryActionLabelKey"
      mat-button
      class="!w-full !ml-0"
      (click)="secondaryAction.emit()">
      {{ secondaryActionLabelKey | translate | uppercase }}
    </button>
  </div>
</mat-dialog-actions>
